type NextLoader = () => Promise<unknown>

const loaders = new Set<NextLoader>()
let preloadActive = false

const whenIdle = (callback: () => void) => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback)
  } else {
    setTimeout(callback, 1)
  }
}

// A failed preload is not an error: the lazy component retries the import when it renders.
const preload = (loader: NextLoader) => whenIdle(() => loader().catch(() => {}))

export const registerNextLoader = (loader: NextLoader) => {
  loaders.add(loader)
  if (preloadActive) preload(loader)
}

/** While active, `next` chunks are fetched in idle time, including those registered later. */
export const setNextPreload = (active: boolean) => {
  preloadActive = active
  if (active) loaders.forEach(preload)
}
